import { gsap } from '../../global/gsap';

const initEventsView = (button) => {
    // Default view
    window.eventView = 'list';

    // Update view with passed params
    const updateView = (params, buttonClicked = null, popstate = false) => {
        // If button clicked, set params first
        if (buttonClicked) {
            params.set('eventView', buttonClicked);
        }

        // If params already exist, eg via popstate update views
        if (params.has('eventView')) {
            const view = params.get('eventView');

            if (view === 'list' || view === 'map') {
                window.eventView = params.get('eventView');

                // If popstate, update param
                if (popstate) {
                    params.set('eventView', view);
                }

                if (view === 'map') {
                    document.body.classList.replace('event-list-active', 'event-map-active');
                    window.eventView = 'map';
                }

                if (view === 'list') {
                    document.body.classList.replace('event-map-active', 'event-list-active');
                    window.eventView = 'list';
                }
            }
        } else {
            document.body.classList.replace('event-map-active', 'event-list-active');
            window.eventView = 'list';
        }

        // Scroll to if button clicked, or page load / pop state if no filter params exist
        if (buttonClicked) {
            const urlString = `${window.location.pathname}?${params.toString()}`;
            window.history.pushState({ path: urlString }, '', urlString);

            gsap.to(window, {
                scrollTo: {
                    y: '#filterScroll',
                    offsetY: 20,
                    autoKill: false
                },
                duration: 0.5
            });
        } else if (params.has('eventView') && params.size === 1) {
            gsap.to(window, {
                scrollTo: {
                    y: '#filterScroll',
                    offsetY: 20,
                    autoKill: false
                },
                duration: 0.5
            });
        }
    };

    // Update view on load
    const loadParams = new URLSearchParams(document.location.search);
    updateView(loadParams);

    // Listeners to update view on click and popstate
    button.addEventListener('click', (event) => {
        event.preventDefault();
        let buttonClicked;

        // Toggle view based on global var
        if (window.eventView === 'list') {
            buttonClicked = 'map';
        } else {
            buttonClicked = 'list';
        }

        const clickParams = new URLSearchParams(document.location.search);
        updateView(clickParams, buttonClicked);
    });

    window.addEventListener('popstate', (event) => {
        const popParams = new URLSearchParams(event.target.location.search);
        updateView(popParams, null, true);
    });
};

export { initEventsView as default };
